import { Tooltip } from "antd";
import type { TooltipProps } from "antd";

export const DarkTooltip = ({ color, placement = "top", styles, ...rest }: TooltipProps) => {
  return (
    <Tooltip
      color={color ?? "#404040"}
      placement={placement}
      arrow={{ pointAtCenter: true }}
      {...rest}
      styles={{
        ...styles,
        container: {
          color: "rgba(255, 255, 255, 0.8)",
          fontSize: 12,
          lineHeight: "16px",
          fontWeight: 400,
          padding: "8px 12px",
          borderRadius: 4,
          border: "none",
          boxShadow: "2px 2px 16px 0 rgba(0, 0, 0, 0.2)",
          ...(styles as any)?.container,
        },
      }}
    />
  );
};
